import React from 'react'
import { Redirect } from 'react-router-dom'

export default function Protected(props) {
        const Component = props.component
        var auth = JSON.parse(localStorage.getItem('auth-token'))
        return (
                <div>
                        {auth ? <Component/> : <Redirect to='/auth' ></Redirect>}
                </div>
        )
}
